import React from "react";
import { Link } from "react-router-dom";
import "./home.css";
import { FaFacebookF, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
        color: "white",
        padding: "40px 20px 20px 20px",
        marginTop: "50px",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "30px",
        }}
      >
        {/* Brand Section */}
        <div
          style={{
            flex: "1",
            minWidth: "200px",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: "0 0 10px 0",
              fontSize: "1.5rem",
              fontWeight: "700",
              color: "#ecf0f1",
              textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            FilingStack
          </h3>
          <p
            style={{
              margin: "0",
              fontSize: "14px",
              color: "#bdc3c7",
              lineHeight: "1.4",
            }}
          >
            Professional accounting solutions for modern businesses
          </p>
          <div
            style={{
              marginTop: "15px",
              fontSize: "12px",
              color: "#95a5a6",
            }}
          >
            © 2025 FilingStack. All rights reserved.
          </div>
        </div>

        {/* Quick Links Section */}
        <div
          style={{
            flex: "1",
            minWidth: "150px",
            marginBottom: "20px",
          }}
        >
          <h4
            style={{
              margin: "0 0 15px 0",
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#ecf0f1",
            }}
          >
            Quick Links
          </h4>
          <ul
            style={{
              listStyle: "none",
              padding: "0",
              margin: "0",
            }}
          >
            <li style={{ marginBottom: "8px" }}>
              <Link
                to="/Signup"
                style={{
                  color: "#bdc3c7",
                  textDecoration: "none",
                  fontSize: "14px",
                  transition: "color 0.2s ease",
                  display: "inline-block",
                }}
                onMouseOver={(e) => (e.target.style.color = "#3498db")}
                onMouseOut={(e) => (e.target.style.color = "#bdc3c7")}
              >
                Sign Up
              </Link>
            </li>
            <li style={{ marginBottom: "8px" }}>
              <a
                href="/UsageInfo"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#bdc3c7",
                  textDecoration: "none",
                  fontSize: "14px",
                  transition: "color 0.2s ease",
                  display: "inline-block",
                }}
                onMouseOver={(e) => (e.target.style.color = "#3498db")}
                onMouseOut={(e) => (e.target.style.color = "#bdc3c7")}
              >
                Documentation
              </a>
            </li>
            <li style={{ marginBottom: "8px" }}>
              <Link
                to="/TermsAndConditions"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#bdc3c7",
                  textDecoration: "none",
                  fontSize: "14px",
                  transition: "color 0.2s ease",
                  display: "inline-block",
                }}
                onMouseOver={(e) => (e.target.style.color = "#3498db")}
                onMouseOut={(e) => (e.target.style.color = "#bdc3c7")}
              >
                Terms & Conditions
              </Link>
            </li>
            <li style={{ marginBottom: "8px" }}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtube.com/@filingstackaccounting4825?feature=shared"
                style={{
                  color: "#bdc3c7",
                  textDecoration: "none",
                  fontSize: "14px",
                  transition: "color 0.2s ease",
                  display: "inline-block",
                }}
                onMouseOver={(e) => (e.target.style.color = "#3498db")}
                onMouseOut={(e) => (e.target.style.color = "#bdc3c7")}
              >
                YouTube Channel
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div
          style={{
            flex: "1",
            minWidth: "200px",
            marginBottom: "20px",
          }}
        >
          <h4
            style={{
              margin: "0 0 15px 0",
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#ecf0f1",
            }}
          >
            Follow Us
          </h4>
          <div
            style={{
              display: "flex",
              gap: "15px",
              alignItems: "center",
            }}
          >
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/FilingStack-Accounting-110181234867936/"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #3b5998 0%, #2d4373 100%)",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(59, 89, 152, 0.3)",
                textDecoration: "none",
                color: "white",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(59, 89, 152, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(59, 89, 152, 0.3)";
              }}
            >
              <FaFacebookF size={20} />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://za.linkedin.com/company/filingstack-accounting?trk=public_profile_topcard-current-company/"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #0077b5 0%, #005885 100%)",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(0, 119, 181, 0.3)",
                textDecoration: "none",
                color: "white",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(0, 119, 181, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(0, 119, 181, 0.3)";
              }}
            >
              <FaLinkedinIn size={20} />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://x.com/FilingStack?s=20"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #000000 0%, #1a1a1a 100%)",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
                textDecoration: "none",
                color: "white",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(0, 0, 0, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(0, 0, 0, 0.3)";
              }}
            >
              <FaXTwitter size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Border */}
      <div
        style={{
          marginTop: "30px",
          paddingTop: "20px",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          textAlign: "center",
          fontSize: "12px",
          color: "#95a5a6",
        }}
      >
        Made with ❤️ for modern businesses
      </div>
    </footer>
  );
}

export default Footer;
